import React from 'react'
import logo from "./assets/imgs/logos/logo.png";
 
const Logo = () => {
  return (
    <img src={logo} className="object-fit-cover companylogo mb-4 mb-md-0" alt="" />
  )
}

export default Logo